import {
  input,
  validations
} from "@/components/Tools/FormHelperFactory/Configurations/baseConfigurations";

export const password = {
  ...input,
  ...validations
};
